import { Box, styled } from '@mui/material'

export const TopologyWrapper = styled(Box)({
  display: 'flex',
  width: '100%',
  flex: 1,
  height: '100%',
  overflow: 'hidden',
})

export const SidebarPanel = styled(Box, {
  shouldForwardProp: (p) => p !== 'isExpanded',
})(({ isExpanded }) => ({
  width: isExpanded ? 0 : '25%',
  minWidth: isExpanded ? 0 : 260,
  maxWidth: isExpanded ? 0 : 340,
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#fff',
  overflow: 'hidden',
  minHeight: 0,
  transition: 'width 0.3s ease, min-width 0.3s ease, max-width 0.3s ease',
}))

export const SidebarHeaderBar = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '6px 16px',
  flexShrink: 0,
})

export const SidebarActions = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  padding: '8px 16px',
  borderBottom: '1px solid #EFEFEF',
  flexShrink: 0,
})

export const ActionButton = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 32,
  height: 32,
  borderRadius: 12,
  cursor: 'pointer',
  border: '1px solid #EFEFEF',
  color: '#464646',
  backgroundColor: 'transparent',
  flexShrink: 0,
  '&:hover': { backgroundColor: '#f3f4f6' },
})

export const StatusButton = styled(Box, {
  shouldForwardProp: (p) => p !== 'active' && p !== 'statusColor',
})(({ active, statusColor }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  padding: '4px 10px',
  borderRadius: 12,
  cursor: 'pointer',
  fontSize: 12,
  fontWeight: 500,
  border: active ? `1px solid ${statusColor}` : '1px solid #EFEFEF',
  backgroundColor: active ? `${statusColor}14` : 'transparent',
  color: active ? statusColor : '#6b7280',
  '&:hover': { borderColor: statusColor },
}))

export const SidebarScrollable = styled(Box)({
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  '&::-webkit-scrollbar': { display: 'none' },
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
})

export const TypeHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '5px 16px',
  cursor: 'pointer',
  fontSize: 13,
  fontWeight: 500,
  color: '#656565',
})

export const CountBadge = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 32,
  height: 20,
  padding: '0 6px',
  borderRadius: '24px',
  fontSize: 11,
  fontWeight: 500,
  border: '1px solid #EFEFEF',
  color: '#6b7280',
  marginLeft: 'auto',
  flexShrink: 0,
})

export const EquipmentItem = styled(Box, {
  shouldForwardProp: (p) => p !== 'selected',
})(({ selected }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '6px 16px 6px 44px',
  cursor: 'pointer',
  borderLeft: selected ? '2px solid #3B82F6' : '2px solid transparent',
  backgroundColor: selected ? '#F0F7FF' : 'transparent',
  '&:hover': { backgroundColor: selected ? '#F0F7FF' : '#FAFAFA' },
}))

export const StatusDot = styled('span', {
  shouldForwardProp: (p) => p !== 'color',
})(({ color }) => ({
  display: 'inline-block',
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: color || '#9ca3af',
  flexShrink: 0,
}))

export const TreeArea = styled(Box)({
  flex: 1,
  position: 'relative',
  backgroundColor: '#FAFAFA',
  overflow: 'hidden',
  borderRadius: 24,
  border: '1px solid #EFEFEF',
  margin: 8,
})

export const TreeCanvasWrapper = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
})

export const ControlsWrapper = styled(Box)({
  position: 'absolute',
  right: 16,
  bottom: 16,
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  zIndex: 10,
})

export const ControlGroup = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  background: '#fff',
  borderRadius: 24,
  border: '1px solid #EFEFEF',
  overflow: 'hidden',
})

export const ControlButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  cursor: 'pointer',
  color: '#6b7280',
  '&:hover': {
    backgroundColor: '#F3F4F6',
    color: theme.palette.primary.main,
  },
}))

export const ControlDivider = styled(Box)({
  height: 1,
  width: 12,
  alignSelf: 'center',
  backgroundColor: '#EFEFEF',
})

export const CaptionContainer = styled(Box)({
  position: 'absolute',
  bottom: 16,
  left: 16,
  display: 'flex',
  flexDirection: 'column',
  padding: '14px 18px',
  background: '#fff',
  border: '1px solid #EFEFEF',
  borderRadius: 16,
  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  zIndex: 10,
})

export const CaptionRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
})

export const CaptionDivider = styled(Box)({
  height: 1,
  backgroundColor: '#EFEFEF',
  margin: '4px 0',
})

export const DetailCardWrapper = styled(Box, {
  shouldForwardProp: (p) => p !== 'open',
})(({ open }) => ({
  position: 'absolute',
  top: 16,
  right: 16,
  width: open ? 260 : 0,
  opacity: open ? 1 : 0,
  maxHeight: 'calc(100% - 32px)',
  borderRadius: 16,
  background: '#fff',
  border: open ? '1px solid #EFEFEF' : 'none',
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  overflow: 'hidden',
  zIndex: 10,
  display: 'flex',
  flexDirection: 'column',
  transition: 'width 0.25s ease, opacity 0.2s ease',
}))

export const DetailRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 0,
  padding: '3px 14px',
  minHeight: 22,
})

export const DetailRowDivider = styled(Box)({
  height: 1,
  backgroundColor: '#F7F7F7',
  margin: '0 14px',
})

export const StatusCircle = styled('span', {
  shouldForwardProp: (p) => p !== 'status',
})(({ status }) => {
  const map = {
    up:          { bg: '#E6F0D7', border: '#587F31' },
    down:        { bg: '#FEE2E2', border: '#DC2626' },
    missing_ref: { bg: '#E7E7E7', border: '#5D5D5D' },
  }
  const c = map[status] || map.missing_ref
  return {
    display: 'inline-block',
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: c.bg,
    border: `1.5px solid ${c.border}`,
    flexShrink: 0,
  }
})

export const ExpandButton = styled(Box)({
  position: 'absolute',
  top: 16,
  left: 16,
  width: 36,
  height: 36,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  background: '#fff',
  border: '1px solid #EFEFEF',
  boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
  cursor: 'pointer',
  color: '#6b7280',
  zIndex: 10,
  '&:hover': { backgroundColor: '#F3F4F6' },
})

